import React from 'react';

export const LazyEnvironment = React.lazy(() => import('./EnvironmentPage'));
export const LazyEnvironmentHistory = React.lazy(() => import('./EnvironmentHistoryPage'));
